<div
  class="flex h-10 justify-between items-center border border-solid border-color-light-shade bg-white rounded-lg transition-all ease-in-out duration-500 overflow-hidden"
  (mouseenter)="showSearchNameInput = true"
  (mouseleave)="showSearchNameInput = !!searchNameInputControl.value?.length"
  [ngClass]="{
    'w-10': !showSearchNameInput && document.activeElement !== inputElement,
    'w-[220px]': showSearchNameInput || document.activeElement === inputElement,
  }"
>
  <div class="w-full max-w-[40px] flex items-center justify-center text-color-primary">
    <mat-icon class="text-[16px] w-[16px] h-[16px] max-h-[16px] max-w-[16px]">search</mat-icon>
  </div>

  <input
    #inputElement
    type="text"
    class="bg-white text-color-text text-sm font-normal outline-none focus:outline-none active:outline-none border-none justify-self-end transition-all ease-in-out duration-500"
    [ngClass]="{
      'opacity-0 w-0 max-w-0 p-0': !showSearchNameInput && document.activeElement !== inputElement,
      'opacity-100 w-full w-max-[100%] pr-1 -ml-2': showSearchNameInput || document.activeElement === inputElement,
    }"
    [placeholder]="placeholder"
    [formControl]="searchNameInputControl"
  />
</div>
